import { useContext } from 'react';
import getApiEndpointsContext, { iApiEndpoint } from './ApiEndpointsContext';

export default () => {
    const context = getApiEndpointsContext();
    const apiEndpoints = useContext(context);

    const getApiEndpointFromUrl = (url: string): iApiEndpoint => {
        const data = Object.entries(apiEndpoints).map(([key, value]) => ({ key: key, endpoint: value }));
        return data.find((x) => x.endpoint.url === url)?.endpoint;
    };

    return { apiEndpoints, getApiEndpointFromUrl };
};
